export default {
  default: null,
  style: 0,
  type: 'Date'
};